import * as Accordion from '@radix-ui/react-accordion';
import styled from 'styled-components';

export const Root = styled(Accordion.Root)`
	gap: 5px;
	display: flex;
	flex-direction: column;
`;

export const Item = styled(Accordion.Item)``;

export const Content = styled(Accordion.Content)`
	max-height: 360px;
	overflow-y: auto;

	button:hover p:first-child {
		color: var(--surface-accent-hover-dark);
	}

	button[data-testid='see-more-filters-btn'] {
		justify-content: start;
	}
`;

export const Trigger = styled(Accordion.Trigger)`
	width: 100%;
	margin-top: 8px;
	padding: 1rem 0 0 0;
	display: flex;
	justify-content: space-between;
	align-items: center;

	cursor: pointer;
	border-top: 1px solid var(--border-primary);

	i {
		transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
		transform: rotate(90deg);
	}

	&[data-state='open'] i {
		transform: rotate(270deg);
	}
`;
